// Redesign 2026 – samostatný bundle (webpack entry `redesign` -> dist/redesign.js).
// Vanilla JS, bez jQuery a Bootstrap JS. Každý modul se hned vrátí, když na stránce nemá svůj markup.
import initRedesignHeader from './header';
import initRedesignOrder from './order';
import initRedesignAsk from './ask';
import initRedesignGallery from './gallery';
import initRedesignCounters from './counters';
import initRedesignProjectFilter from './project-filter';
import initRedesignDocFilter from './doc-filter';
import initRedesignOtazky from './otazky';
import initRedesignOfferSlides from './offer-slides';
import initRedesignFfAgain from './ff-again';
import initRedesignKariera from './kariera';
import initRedesignVydane from './vydane';
import initRedesignVideo from './video';
import initRedesignFormSwitch from './form-switch';

document.addEventListener('DOMContentLoaded', () => {
  initRedesignHeader();
  initRedesignOrder(); // sekce Předobjednávka ([data-rd-order]) – LP /dluhopisy i detail emise
  initRedesignAsk(); // sekce Žádost o informaci ([data-rd-ask])
  initRedesignGallery(); // galerie s lightboxem ([data-rd-gallery]) – detail Račice
  initRedesignCounters(); // dopočítávání čísel ([data-rd-count]) – homepage, Portfolio
  initRedesignProjectFilter(); // filtr projektů ([data-rd-project-filter]) – Portfolio investic
  initRedesignDocFilter(); // filtr dokumentů ([data-rd-doc-filter]) – Sbírka listin
  initRedesignOtazky(); // filtr otázek podle tématu ([data-rd-faq-list]) – Otázky a odpovědi
  initRedesignOfferSlides(); // dlaždice / carousel nabídky ([data-rd-slides]) – homepage, LP /dluhopisy
  initRedesignFfAgain(); // „Odeslat další objednávku“ v poděkování Fluent Formu ([data-rd-ff-again]) – FONDEFI
  initRedesignKariera(); // karusel kategorií a výběr kategorie pozic ([data-rd-kariera]) – Kariéra
  initRedesignVydane(); // hledání, filtr a rozbalení skupin emisí ([data-rd-vd]) – Vydané dluhopisy
  initRedesignVideo(); // video s náhledovou fotkou ([data-rd-video]) – detail emise Račice
  initRedesignFormSwitch(); // přepínač formulářů tlačítky ([data-rd-form-switch]) – Recepce
});
